import { useCallback, useState } from 'react';
import { App } from 'antd';
import { skuAPI } from '../../../../services/api';

export const useSKUFABE = (onSuccess: () => void) => {
    const { message } = App.useApp();

    const [fabeModalVisible, setFabeModalVisible] = useState(false);
    const [fabeLoading, setFabeLoading] = useState(false);
    const [currentSellingPoint, setCurrentSellingPoint] = useState('');
    const [, setCurrentSellingPointIndex] = useState(0);
    const [currentFABEData, setCurrentFABEData] = useState<any>(null);
    const [, setCurrentSKUId] = useState<number | null>(null);

    const handleGenerateFABE = useCallback(async (skuId: number, sellingPoint: string, index: number) => {
        if (!sellingPoint.trim()) {
            message.warning('卖点内容不能为空');
            return;
        }

        setCurrentSKUId(skuId);
        setCurrentSellingPoint(sellingPoint);
        setCurrentSellingPointIndex(index);
        setFabeLoading(true);
        setFabeModalVisible(true);
        setCurrentFABEData(null);

        try {
            const response = await skuAPI.generateSellingPointFABE(skuId, sellingPoint, index);
            const fabeData = response.data.fabe;

            setCurrentFABEData(fabeData);
            message.success('FABE 分析生成成功！');
        } catch (error: any) {
            message.error(error.userMessage || 'FABE 生成失败');
            setFabeModalVisible(false);
        } finally {
            setFabeLoading(false);
        }
    }, [message]);

    const handleConfirmFABE = useCallback(() => {
        message.success('FABE 数据已保存到 SKU');
        setFabeModalVisible(false);
        onSuccess();
    }, [onSuccess, message]);

    const handleCancelFABE = useCallback(() => {
        setFabeModalVisible(false);
        setCurrentFABEData(null);
    }, []);

    return {
        handleGenerateFABE,
        handleConfirmFABE,
        handleCancelFABE,
        fabeModalVisible,
        fabeLoading,
        currentSellingPoint,
        currentFABEData,
    };
};
